import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

type Props = {
  state: any;
  onChange?: (...args: any[]) => void;
  onBlur?: (...args: any[]) => void;
  label: string;
  name: string;
  error?: string | null;
  dataTestId?: string;
};

export const PaymentTextInput = ({
  state,
  onChange,
  onBlur,
  label,
  name,
  dataTestId,
  error = null
}: Props) => {
  return (
    <Box>
      <TextField
        label={label}
        name={name}
        variant="outlined"
        size="small"
        error={!!error}
        helperText={error}
        required
        fullWidth
        value={state}
        onChange={onChange}
        onBlur={onBlur}
        InputLabelProps={{
          sx: {
            marginTop: '5px',
            '&.Mui-focused': {
              marginTop: 0
            }
          }
        }}
        data-testid={dataTestId}
      />
    </Box>
  );
};
